import ServicePage from '../../components/Pages/ServicePage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function ServicePageWrapper() {
  const shouldBePage = pages.service;
  const conditionTypes = {
    page: true,
  };

  return (
    <PageWrapper
      pageToLoad={<ServicePage />}
      shouldBePage={shouldBePage}
      conditions={conditionTypes}
    />
  );
}
